import { render, staticRenderFns } from "./BurnListExecute.vue?vue&type=template&id=8d8dee22&scoped=true&"
import script from "./BurnListExecute.vue?vue&type=script&lang=js&"
export * from "./BurnListExecute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8dee22",
  null
  
)

export default component.exports